import axios from 'axios';
import QueryString from 'qs';
import { Statistics } from '../interfaces/statistics';

const instance = axios.create();

const { REACT_APP_API_URL } = process.env;

export const find = async ({
  token,
  query,
}: {
  token?: string | null;
  query?: Object;
}): Promise<Statistics> => {
  const { data: receipts } = await instance.get<Statistics>(
    `${REACT_APP_API_URL}/statistics?${QueryString.stringify(query)}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return receipts;
};

export const calculate = async ({
  token,
  query,
}: {
  token?: string | null;
  query?: Object;
}): Promise<Statistics> => {
  const { data: statistics } = await instance.get<Statistics>(
    `${REACT_APP_API_URL}/statistic/calculate?${QueryString.stringify(query)}`,
    {
      headers: { authorization: `Bearer ${token}` },
    }
  );
  return statistics;
};

export const downloadComparisonStatisticsCSV = async ({
  token,
  date,
}: {
  token: string | null;
  date?: string;
}) => {
  const query = {
    date,
  };

  const response = await axios.get(
    `${REACT_APP_API_URL}/statistic/comparison-csv?${QueryString.stringify(
      query
    )}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    }
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'comparison-statistics.csv');
  document.body.appendChild(link);
  link.click();
  link.remove();
};

const statisticsAPIs = {
  find,
  calculate,
  downloadComparisonStatisticsCSV,
};

export default statisticsAPIs;
